// extracted by mini-css-extract-plugin
export default {"errorboundary__container":"errorboundary_errorboundary__container__sqSXO","h3__text":"errorboundary_h3__text__8RTRj","p__text":"errorboundary_p__text__FSIRm"};